module.exports = __webpack_public_path__ + "img/placeholder_note.28d254fa.png";